
const formatCurrency = function(currency) {
    currency = currency + "";
    if (currency.length <= 3) return currency;
    return formatCurrency(currency.substring(0, currency.length - 3)) + "," + currency.substring(currency.length - 3)
}

const wakeupApp = () => {
    let isAndroid = /(Android)|(Linux)/.test(window.navigator.userAgent);
    let isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(window.navigator.userAgent);
    if (isAndroid || isIos) {
        let schemeURL = "drbingo://lobby", storeURL = isAndroid ? "https://play.google.com/store/apps/details?id=com.gamesmartltd.doctorbingo": "https://itunes.apple.com/app/id1152226735";
        let timer = null, wind = null, timestamp = Date.now();

        if (isIos) {
            wind = window.open("https://" + window.location.hostname + "/wakeup.html");
        } else {
            wind = document.createElement("iframe");
            wind.src = schemeURL;
            wind.style.display = "none";
            document.body.appendChild(wind);
        }

        timer = setTimeout(() => {
            if (Date.now() - timestamp > 3000) {
                if (isIos) {
                    !wind.closed && window.close()
                } else document.body.removeChild(wind)
            } else window.location.href = storeURL;
        }, 2000)
    } else {
        window.location.href = "https://oneclick.doutorbingo.com";
    }

    // 第二个方法  监听页面可视性变化事件+定时器   visibilitychange、msvisibilitychange、webkitvisibilitychange   document.hidden
}

const animation = (duration, start, end, onProgress, onComplete) => {
    let startTime = Date.now(), speed = (end - start) / duration;
    const _running = () => {
        let now = Date.now();
        let current = start + speed * (now - startTime);
        if (now - startTime > duration) {
            onComplete ? onComplete(end): onProgress(end);
            return;
        } else {
            onProgress && onProgress(current);
            requestAnimationFrame(_running);
        }
    }
    _running();
}

export default {
    fc: formatCurrency,
    wakeupApp: wakeupApp,
    animation: animation
}



// WEBPACK FOOTER //
// ./src/utils/utils.js